import { useContext } from "react";
import { Button, Grid } from "@pushpress/shared-components";
import UploadMembersCard from "./UploadMembersCard";
import { AssignPlansCard } from "./plans/AssignPlansCard";
import { ReviewAndActivateCard } from "./activate/ReviewAndActivateCard";
import { AppContext } from "../../../context/app";
import { useFeatureFlag } from "../../../context/features";
import { SHOW_PAYMENT_MIGRATION } from "../../../context/features/features.utils";
import { isLocal, isDev } from "../../../env";
type MigratingTabViewType = {
  membersReadyForActivationCount: number;
  membersWithPlansCount: number;
  migratingMembersCount: number;
  preventActivation: boolean;
  setIsStripeModalVisible: (value: boolean) => void;
  setShowAssignPlansPage: (value: boolean) => void;
  setIsActivateModalOpen: (value: boolean) => void;
};

export default function MigratingTabView({
  membersReadyForActivationCount,
  membersWithPlansCount,
  migratingMembersCount,
  preventActivation,
  setIsStripeModalVisible,
  setShowAssignPlansPage,
  setIsActivateModalOpen,
}: MigratingTabViewType) {
  const { user } = useContext(AppContext);
  const { isFeatureEnabled } = useFeatureFlag();
  const showPaymentMigrationTool =
    isFeatureEnabled(SHOW_PAYMENT_MIGRATION) || isLocal() || isDev();

  const disableAssignPlans = migratingMembersCount <= 0;
  const disableActivate = membersReadyForActivationCount <= 0;
  const mainPage = window.location.origin;

  const showInternalContent = user.superuser || isLocal() || isDev();

  return (
    <>
      {showInternalContent && showPaymentMigrationTool && (
        <Grid container justifyContent="flex-end" marginY={2}>
          <Button
            buttonType="secondary"
            text="Payment matching tool"
            size="large"
            onClick={() =>
              (window.location.href = `${mainPage}/migration-assistant/payment-migration`)
            }
          />
        </Grid>
      )}
      <UploadMembersCard migratingMembersCount={migratingMembersCount} />
      <AssignPlansCard
        disableAssignPlans={disableAssignPlans}
        migratingMembersCount={migratingMembersCount}
        membersWithPlansCount={membersWithPlansCount}
        setShowAssignPlansPage={setShowAssignPlansPage}
      />
      <ReviewAndActivateCard
        preventActivation={preventActivation}
        setIsStripeModalVisible={setIsStripeModalVisible}
        disableActivate={disableActivate}
        membersReadyForActivationCount={membersReadyForActivationCount}
        setIsActivateModalOpen={setIsActivateModalOpen}
      />
    </>
  );
}
